export default {"src":"/_next/static/media/avax.f6d57d19.svg","height":1504,"width":1503};